import EmailReader from '@admin/components/email_reader'
import Panel from '@admin/components/panel'
import React from 'react'

const getEmailReader = (email) => ({
  endpoint: `/api/admin/automation/emails/${email.id}/replies`,
  perspective: 'incoming',
  show_interactions: false,
  show_outcome: true
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Replies)',
  component: <EmailReader { ...getEmailReader(props.email) } />
})

export default Panel(null, mapPropsToPanel)
